﻿//Jquery
import "./jquery-global.js";
import $, {ajax} from "jquery";

import Swiper from 'swiper/swiper-bundle.min.js';

let xlMinWidth = window.matchMedia("(min-width: 1200px)");
let relatedProductSwiper;
let featureBarSwiper;

export function initiate_Carousels() {

    xlMinWidthHandler(xlMinWidth);
    xlMinWidth.addListener(xlMinWidthHandler);


    $('.featured-product .enable-carousel').each(function (index) {
        let self = $(this);
        self.closest('.featured-product').addClass('swiper-' + index);
        let xlCount = parseInt(self.data('xl'));
        let lgCount = parseInt(self.data('lg'));
        let mdCount = parseInt(self.data('md'));
        let smCount = parseInt(self.data('sm'));
        let xsCount = parseInt(self.data('xs'));

        let featuredProductSwiper = new Swiper('.featured-product.swiper-' + index + ' .enable-carousel', {
            spaceBetween: 24,
            navigation: {
                nextEl: '.featured-product.swiper-' + index + ' .swiper-button-next',
                prevEl: '.featured-product.swiper-' + index + ' .swiper-button-prev',
            },
            breakpoints: {
                // mobile
                0: {
                    slidesPerView: xsCount
                },
                // small
                576: {
                    slidesPerView: smCount
                },
                // medium
                768: {
                    slidesPerView: mdCount
                },
                // large
                992: {
                    slidesPerView: lgCount
                },
                // x-large
                1200: {
                    slidesPerView: xlCount,
                }
            }
        });
    });

    $('.brands .enable-carousel').each(function (index) {
        let self = $(this);
        self.closest('.brands').addClass('swiper-' + index);
        let xlCount = parseInt(self.data('xl'));
        let lgCount = parseInt(self.data('lg'));
        let mdCount = parseInt(self.data('md'));
        let smCount = parseInt(self.data('sm'));
        let xsCount = parseInt(self.data('xs'));

        let brandSwiper = new Swiper('.brands.swiper-' + index + ' .enable-carousel', {
            spaceBetween: 0,
            navigation: {
                nextEl: '.brands.swiper-' + index + ' .swiper-button-next',
                prevEl: '.brands.swiper-' + index + ' .swiper-button-prev',
            },
            breakpoints: {
                // mobile
                0: {
                    slidesPerView: xsCount,
                    spaceBetween: 16
                },
                // small
                576: {
                    slidesPerView: smCount
                },
                // medium
                768: {
                    slidesPerView: mdCount
                },
                // large
                992: {
                    slidesPerView: lgCount
                },
                // x-large
                1200: {
                    slidesPerView: xlCount,
                }
            }
        });
    });

    $('.branch-gallery .enable-carousel').each(function (index) {
        let self = $(this);
        self.closest('.branch-gallery').addClass('swiper-' + index);
        let xlCount = parseInt(self.data('xl'));
        let lgCount = parseInt(self.data('lg'));
        let mdCount = parseInt(self.data('md'));
        let smCount = parseInt(self.data('sm'));
        let xsCount = parseInt(self.data('xs'));

        let branchGallerySwiper = new Swiper('.branch-gallery.swiper-' + index + ' .enable-carousel', {
            spaceBetween: 24,
            navigation: {
                nextEl: '.branch-gallery.swiper-' + index + ' .swiper-button-next',
                prevEl: '.branch-gallery.swiper-' + index + ' .swiper-button-prev',
            },
            breakpoints: {
                // mobile
                0: {
                    slidesPerView: xsCount,
                },
                // small
                576: {
                    slidesPerView: smCount
                },
                // medium
                768: {
                    slidesPerView: mdCount
                },
                // large
                992: {
                    slidesPerView: lgCount
                },
                // x-large
                1200: {
                    slidesPerView: xlCount,
                }
            }
        });
    });

    let cardSliderSelector = $('.card-slider .enable-carousel');
    cardSliderSelector.each(function (index) {
        let self = $(this);
        self.closest('.card-slider').addClass('swiper-' + index);
        let xlCount = parseInt(self.data('xl'));
        let lgCount = parseInt(self.data('lg'));
        let mdCount = parseInt(self.data('md'));
        let smCount = parseInt(self.data('sm'));
        let xsCount = parseInt(self.data('xs'));

        let cardSliderSwiper = new Swiper('.card-slider.swiper-' + index + ' .enable-carousel', {
            spaceBetween: 16,
            loop: true,
            rewind: true,
            watchSlidesProgress: true,
            slideVisibleClass: "swiper-visible-slide",
            navigation: {
                nextEl: '.card-slider.swiper-' + index + ' .swiper-button-next',
                prevEl: '.card-slider.swiper-' + index + ' .swiper-button-prev',
            },
            breakpoints: {
                // mobile
                0: {
                    slidesPerView: xsCount,
                    spaceBetween: 64,
                },
                // small
                576: {
                    slidesPerView: smCount,
                },
                // medium
                768: {
                    slidesPerView: mdCount,
                },
                // large
                992: {
                    slidesPerView: lgCount,
                },
                // x-large
                1200: {
                    slidesPerView: xlCount,
                }
            }
        });
    });

    let relatedBasketSwiper = new Swiper(".related-basket-product .enable-carousel", {
        spaceBetween: 24,
        navigation: {
            nextEl: '.related-basket-product .swiper-button-next',
            prevEl: '.related-basket-product .swiper-button-prev',
        },
        breakpoints: {
            // mobile
            0: {
                slidesPerView: 1
            },
            // medium
            768: {
                slidesPerView: 2
            },
            //x-large
            1200: {
                slidesPerView: 3,
                loop: false
            }
        }
    });
}

function destroyFeatureBarSwiper() {
    let carouselWrapper = $('.feature-bar .carousel-wrapper');
    //Destroy swiper on xl devices
    if (featureBarSwiper) {
        featureBarSwiper.destroy(true, false);
        carouselWrapper.find('.swiper-slide').removeAttr('style');
        carouselWrapper.find('.swiper-slide').removeAttr('aria-label');
        carouselWrapper.find('.swiper-slide').removeAttr('role');
        carouselWrapper.find('.swiper-slide').attr("class", "col");
        carouselWrapper.html(carouselWrapper.children('.swiper-wrapper').html());
        carouselWrapper.attr("class", 'row carousel-wrapper');
    }
}

function initFeatureBarSwiper() {
    let carouselWrapper = $('.feature-bar .carousel-wrapper');
    //Initiate swiper on smaller devices than xl
    carouselWrapper.attr("class",'swiper carousel-wrapper');
    carouselWrapper.children('.col').attr("class","swiper-slide");
    carouselWrapper.html(`<div class="swiper-wrapper">${carouselWrapper.html()}</div>`);

    featureBarSwiper = new Swiper(".feature-bar .swiper", {
        loop: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        rewind: true,
        watchSlidesProgress: true,
        slideVisibleClass: "swiper-visible-slide",
        breakpoints: {
            // mobile
            0: {
                slidesPerView: 1
            },
            // small
            576: {
                slidesPerView: 2
            },
            // medium
            768: {
                slidesPerView: 3
            },
            //x-large
            1200: {
                slidesPerView: 4,
                loop: false
            }
        }
    });
}

function destroyRelatedProductSwiper() {
    let carouselWrapper = $('.related-products .carousel-wrapper');
    //Destroy swiper on xl devices
    if (relatedProductSwiper) {
        relatedProductSwiper.destroy(true, false);
        carouselWrapper.find('.swiper-slide').removeAttr('style');
        carouselWrapper.find('.swiper-slide').removeAttr('aria-label');
        carouselWrapper.find('.swiper-slide').removeAttr('role');
        carouselWrapper.find('.swiper-slide').attr("class", "col-12 col-xl-6 mb-4");
        carouselWrapper.html(carouselWrapper.children('.swiper-wrapper').html());
        carouselWrapper.attr("class", 'row carousel-wrapper');
        carouselWrapper.closest('.related-products').find('.swiper-button-next').remove();
        carouselWrapper.closest('.related-products').find('.swiper-button-prev').remove();
        carouselWrapper.closest('.related-products').remove("mb-4");
    }
}

function initRelatedProductSwiper() {
    let carouselWrapper = $('.related-products .carousel-wrapper');
    //Initiate swiper on smaller devices than xl
    carouselWrapper.attr("class",'swiper px-3 mx-n3 carousel-wrapper');
    carouselWrapper.children('.col-12').attr("class","swiper-slide");
    carouselWrapper.html(`<div class="swiper-wrapper">${carouselWrapper.html()}</div>`);
    carouselWrapper.closest('.related-products').append(`
            <div class="swiper-button-next" aria-label="Next slide">
                <div class='bg-white text-primary drop-shadow rounded-circle px-2 py-1'><i class='bi bi-caret-right-fill fs-18'></i></div>
            </div>
            <div class="swiper-button-prev" aria-label="Previous slide">
                <div class='bg-white text-primary drop-shadow rounded-circle px-2 py-1'><i class='bi bi-caret-left-fill fs-18'></i></div>
            </div>`);
    carouselWrapper.closest('.related-products').addClass("mb-4");

    relatedProductSwiper = new Swiper(carouselWrapper[0], {
        spaceBetween: 24,
        navigation: {
            nextEl: '.related-products .swiper-button-next',
            prevEl: '.related-products .swiper-button-prev',
        },
        breakpoints: {
            // mobile
            0: {
                slidesPerView: 1
            },
            // small
            576: {
                slidesPerView: 2,
            },
            // medium
            768: {
                slidesPerView: 3
            },
            //x-large
            1200: {
                slidesPerView: 4
            }
        }
    });
}


function xlMinWidthHandler(e) {
    if (e.matches) {
        destroyFeatureBarSwiper();
        destroyRelatedProductSwiper();
    } else {
        initFeatureBarSwiper();
        initRelatedProductSwiper();
    }
}